<template>
    <div>
        <div class="online-dossier__image" v-if="featuredImage">
            <img :src="featuredImage">
        </div>

        <div class="online-dossier__top" :class="{ 'mt-2': !featuredImage}"></div>

        <div class="online-dossier__wrapper">
            <h1>{{ onlineDossier.street }} {{ onlineDossier.housenumber ? onlineDossier.housenumber : '' }} {{ onlineDossier.housenumber_addition ? onlineDossier.housenumber_addition : '' }}, {{ onlineDossier.city }}</h1>

            <h3>Opnamegegevens</h3>

            <table width="100%">
                <tr>
                    <td  width="300">Uitvoerende opname - expert(s)</td>
                    <td>{{ getInspectors }}</td>
                </tr>
                <tr>
                    <td>Opnamedatum</td>
                    <td>{{ getInspectionDates }}</td>
                </tr>
                <tr v-if="onlineDossier.inspections[0]">
                    <td>Weersomstandigheden</td>
                    <td>{{ onlineDossier.inspections[0].weather }}</td>
                </tr>
                <tr v-if="onlineDossier.inspections[0] && onlineDossier.inspections[0].limited_by">
                    <td>Beperkt door</td>
                    <td>{{ onlineDossier.inspections[0].limited_by }}</td>
                </tr>
            </table>

            <h3 class="mt-3">Objectgegevens</h3>

            <table width="100%" class="mb-3">
                <tr>
                    <td width="300">Soort object</td>
                    <td>{{ onlineDossier.type }}</td>
                </tr>
                <tr>
                    <td>Plaats</td>
                    <td>{{ onlineDossier.city }}</td>
                </tr>
            </table>

            <div v-if="getLocations.interior.length > 0" class="category">
                <h2>Interieur</h2>
                <Location v-for="location in getLocations.interior" :location="location" :key="location.location.id"/>
            </div>

            <div v-if="getLocations.exterior.length > 0" class="category">
                <h2>Exterieur</h2>
                <Location v-for="location in getLocations.exterior" :location="location" :key="location.location.id"/>
            </div>

            <div v-if="getLocations.infra.length > 0" class="category">
                <h2>Infra</h2>
                <Location v-for="location in getLocations.infra" :location="location" :key="location.location.id"/>
            </div>
        </div>
    </div>
</template>

<script>
	import moment from 'moment-timezone'
	import { mapGetters } from 'vuex'
	import Location from '@/components/online-dossier/Location'

	export default {
		components: { Location },

		computed: {
			...mapGetters([
				'onlineDossier',
			]),

			featuredImage () {
				if (this.onlineDossier.images && this.onlineDossier.images.length > 0) {
					return this.onlineDossier.images[0].paths.hd
				}

				return false
			},

			getInspectors () {
				let inspectors = []

				this.onlineDossier.schedule.map((schedule) => {
					schedule.dates.map((date) => {
						date.inspectors.map((inspector) => {
							inspectors.push(inspector.name)
						})
					})
				})

				return inspectors.filter((value, index, self) => {
					return self.indexOf(value) === index
				}).join(', ')
			},

			getInspectionDates () {
				let dates = []

				this.onlineDossier.schedule.map((schedule) => {
					schedule.dates.map((date) => {
						dates.push(moment(date.date).locale('nl').format('LL'))
					})
				})

				return dates.filter((value, index, self) => {
					return self.indexOf(value) === index
				}).join(', ')
			},

			getLocations () {
				let locations = {
					interior: [],
					exterior: [],
					infra: [],
				}

				this.onlineDossier.inspections.map((inspection) => {
					inspection.locations.map((location) => {
						locations[location.type].push({
							location: location,
							damages: location.damages,
						})
					})
				})

				return locations
			},
		},

		beforeRouteUpdate(to, from, next) {
			this.$emit('hideOffcanvas');

			next();
		}
	}
</script>